import { Typography } from "@bca/ui-library";

export const ClaimsText = () => {
  return (
    <Typography variant="body-small" color="grey-blue" margin="5px 0">
      No claims accepted
    </Typography>
  );
};
